import React from 'react';
import { useNavigate } from 'react-router-dom';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import Button from '@atlaskit/button';
import { AUTH_URL_LOGIN } from '../UrlMap';

export const HEAD_CONTENT = 'Service not activated';
export const BODY_CONTENT =
  'Unfortunately,Customer Portal service is not activated in current plan. Do you want to enable it? Go to the admin side and upgrade the plan';
const ModuleException = () => {
  const navigate = useNavigate();
  return (
    <Modal autoFocus={false} testId={'popup-modal'}>
      <ModalHeader>
        <ModalTitle>{HEAD_CONTENT}</ModalTitle>
      </ModalHeader>
      <ModalBody>{BODY_CONTENT}</ModalBody>
      <ModalFooter>
        <div />
        <div>
          <Button appearance={'subtle'} onClick={() => navigate(AUTH_URL_LOGIN)} testId={'cancel-btn'}>
            Back
          </Button>
          {/* <Button testId={'save-btn'} appearance={'primary'} onClick={() => history.push(BILLING_HOME_URL)}>
            Upgrade Plan
          </Button> */}
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default ModuleException;
